import MacbookImage from './images/MacbookAir_Masked_Image.webp'
import MacbookOuterMask from './images/MacbookAir_Masked_OuterMask.webp'
import MacbookInnerMask from './images/MacbookAir_Masked_InnerMask.webp'
import iPhone16Image from './images/Iphone_16_Mockup_Image.webp'
import iPhone16OuterMask from './images/Iphone_16_Mockup_OuterMask.webp'
import iPhone16InnerMask from './images/Iphone_16_Mockup_InnerMask.webp'
import iPhone16AngledImage from './images/Iphone_16_Angled_Mockup_Image.webp'
import iPhone16AngledOuterMask from './images/Iphone_16_Angled_Mockup_OuterMask.webp'
import iPhone16AngledInnerMask from './images/Iphone_16_Angled_Mockup_InnerMask.webp'
import { browsers } from './browsers'

export const devices = {
  MacbookAir: {
    width: 1440,
    height: 900,
    perspective: 0,
    rotation: [0, 0, 0],
    relativeCenter: ['50%', '48%'],
    relativeWidth: 0.82,
    image: MacbookImage,
    innerMask: MacbookInnerMask,
    outerMask: MacbookOuterMask,
    browserUi: browsers.safariDesktop,
    shadow: {
      width: '95%',
      height: '3%',
      offsetFromRelativeCenterX: '0%',
      offsetFromRelativeCenterY: '50%',
      radius: 'full',
    },
  },
  iPhone16: {
    image: iPhone16Image,
    innerMask: iPhone16InnerMask,
    outerMask: iPhone16OuterMask,
    width: 393,
    height: 852,
    perspective: 0,
    rotation: [0, 0, 0],
    relativeCenter: ['50%', 'calc(50% + 1px)'],
    relativeWidth: 0.89,
    browserUi: browsers.safariIphone,
    shadow: {
      width: '100%',
      height: '90%',
      offsetFromRelativeCenterX: '0%',
      offsetFromRelativeCenterY: '2%',
      radius: '4rem',
    },
  },
  iPhone16Angled: {
    image: iPhone16AngledImage,
    innerMask: iPhone16AngledInnerMask,
    outerMask: iPhone16AngledOuterMask,
    width: 393,
    height: 852,
    perspective: '45cm',
    rotation: [0, 47, 0],
    relativeCenter: ['59.3%', 'calc(89.5%)'],
    relativeWidth: 1.2,
    browserUi: browsers.safariIphone,
    shadow: undefined,
  },
} as const

export type DeviceType = keyof typeof devices

export type DeviceMockupSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'fit-container'

// Phone sizes (baseline)
export const phoneSizeWidths: Record<DeviceMockupSize, string> = {
  xs: 'w-32',
  sm: 'w-48',
  md: 'w-72',
  lg: 'w-96',
  xl: 'w-[480px]',
  'fit-container': 'w-full h-full',
}

export const phoneSizeWidthPixels: Record<DeviceMockupSize, number | undefined> = {
  xs: 128,
  sm: 192,
  md: 288,
  lg: 384,
  xl: 480,
  'fit-container': undefined,
}

// Laptop sizes — scaled up by ~1.86x so visual area matches phone at same size
// (phone aspect 393:852 has ~3.47x the area of laptop aspect 1440:900 at same width)
export const laptopSizeWidths: Record<DeviceMockupSize, string> = {
  xs: 'w-60',
  sm: 'w-[360px]',
  md: 'w-[540px]',
  lg: 'w-[720px]',
  xl: 'w-[896px]',
  'fit-container': 'w-full h-full',
}

export const laptopSizeWidthPixels: Record<DeviceMockupSize, number | undefined> = {
  xs: 240,
  sm: 360,
  md: 540,
  lg: 720,
  xl: 896,
  'fit-container': undefined,
}

// Switcher container: width = laptop width, height = phone height at that size
// This way both devices render at their actual size variant dimensions with no layout shift.
// containerMatchesDeviceWidth shrinks the width to phone width when phone is active.
const phoneHeightRatio = devices.iPhone16.height / devices.iPhone16.width // ~2.168

export const switcherSizePixels: Record<DeviceMockupSize, { width: number; height: number } | undefined> = {
  xs: { width: 240, height: 128 * phoneHeightRatio },
  sm: { width: 360, height: 192 * phoneHeightRatio },
  md: { width: 540, height: 288 * phoneHeightRatio },
  lg: { width: 720, height: 384 * phoneHeightRatio },
  xl: { width: 896, height: 480 * phoneHeightRatio },
  'fit-container': undefined,
}
